// extracted by mini-css-extract-plugin
module.exports = {"modal-icon":"styles_modal-icon__dJruw"};